module.exports = __webpack_public_path__ + "img/pencil.2b093c93.svg";